/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { DataTakerStaffDataModel } from '../models/data-taker-staff-data-model';
import { GetBehaviorGraph } from '../fn/graph/get-behavior-graph';
import { GetBehaviorGraph$Params } from '../fn/graph/get-behavior-graph';
import { GetDataTakerStaffsForBehaviorID } from '../fn/graph/get-data-taker-staffs-for-behavior-id';
import { GetDataTakerStaffsForBehaviorID$Params } from '../fn/graph/get-data-taker-staffs-for-behavior-id';
import { GetGraphAnnotations } from '../fn/graph/get-graph-annotations';
import { GetGraphAnnotations$Params } from '../fn/graph/get-graph-annotations';
import { GetMixedGraph } from '../fn/graph/get-mixed-graph';
import { GetMixedGraph$Params } from '../fn/graph/get-mixed-graph';
import { GetProgramGraph } from '../fn/graph/get-program-graph';
import { GetProgramGraph$Params } from '../fn/graph/get-program-graph';
import { GetSessionEntriesForBehavior } from '../fn/graph/get-session-entries-for-behavior';
import { GetSessionEntriesForBehavior$Params } from '../fn/graph/get-session-entries-for-behavior';
import { GetSessionEntriesForTarget } from '../fn/graph/get-session-entries-for-target';
import { GetSessionEntriesForTarget$Params } from '../fn/graph/get-session-entries-for-target';
import { GetStaffTargetComplianceReport } from '../fn/graph/get-staff-target-compliance-report';
import { GetStaffTargetComplianceReport$Params } from '../fn/graph/get-staff-target-compliance-report';
import { GetTargetGraph } from '../fn/graph/get-target-graph';
import { GetTargetGraph$Params } from '../fn/graph/get-target-graph';
import { GraphAnnotationModel } from '../models/graph-annotation-model';
import { GraphDataModel } from '../models/graph-data-model';
import { MarkGraphAnnotationAsDeleted } from '../fn/graph/mark-graph-annotation-as-deleted';
import { MarkGraphAnnotationAsDeleted$Params } from '../fn/graph/mark-graph-annotation-as-deleted';
import { PatientSessionDataModel } from '../models/patient-session-data-model';
import { SaveGraphAnnotation } from '../fn/graph/save-graph-annotation';
import { SaveGraphAnnotation$Params } from '../fn/graph/save-graph-annotation';
import { SetGraphAnnotationVisibility } from '../fn/graph/set-graph-annotation-visibility';
import { SetGraphAnnotationVisibility$Params } from '../fn/graph/set-graph-annotation-visibility';
import { StaffTargetComplianceReportModel } from '../models/staff-target-compliance-report-model';

@Injectable({ providedIn: 'root' })
export class GraphApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiGraphGetProgramGraphGet()` */
  static readonly ApiGraphGetProgramGraphGetPath = '/api/Graph/GetProgramGraph';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetProgramGraph()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetProgramGraph$Response(params?: GetProgramGraph$Params, context?: HttpContext): Observable<StrictHttpResponse<GraphDataModel>> {
    return GetProgramGraph(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetProgramGraph$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetProgramGraph(params?: GetProgramGraph$Params, context?: HttpContext): Observable<GraphDataModel> {
    return this.GetProgramGraph$Response(params, context).pipe(
      map((r: StrictHttpResponse<GraphDataModel>): GraphDataModel => r.body)
    );
  }

  /** Path part for operation `apiGraphGetTargetGraphGet()` */
  static readonly ApiGraphGetTargetGraphGetPath = '/api/Graph/GetTargetGraph';

  /**
   * This is the main method for generating the graphs for targets.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetTargetGraph()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetTargetGraph$Response(params?: GetTargetGraph$Params, context?: HttpContext): Observable<StrictHttpResponse<GraphDataModel>> {
    return GetTargetGraph(this.http, this.rootUrl, params, context);
  }

  /**
   * This is the main method for generating the graphs for targets.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetTargetGraph$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetTargetGraph(params?: GetTargetGraph$Params, context?: HttpContext): Observable<GraphDataModel> {
    return this.GetTargetGraph$Response(params, context).pipe(
      map((r: StrictHttpResponse<GraphDataModel>): GraphDataModel => r.body)
    );
  }

  /** Path part for operation `apiGraphGetSessionEntriesForTargetGet()` */
  static readonly ApiGraphGetSessionEntriesForTargetGetPath = '/api/Graph/GetSessionEntriesForTarget';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetSessionEntriesForTarget()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetSessionEntriesForTarget$Response(params?: GetSessionEntriesForTarget$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PatientSessionDataModel>>> {
    return GetSessionEntriesForTarget(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetSessionEntriesForTarget$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetSessionEntriesForTarget(params?: GetSessionEntriesForTarget$Params, context?: HttpContext): Observable<Array<PatientSessionDataModel>> {
    return this.GetSessionEntriesForTarget$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PatientSessionDataModel>>): Array<PatientSessionDataModel> => r.body)
    );
  }

  /** Path part for operation `apiGraphGetStaffTargetComplianceReportGet()` */
  static readonly ApiGraphGetStaffTargetComplianceReportGetPath = '/api/Graph/GetStaffTargetComplianceReport';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetStaffTargetComplianceReport()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetStaffTargetComplianceReport$Response(params?: GetStaffTargetComplianceReport$Params, context?: HttpContext): Observable<StrictHttpResponse<StaffTargetComplianceReportModel>> {
    return GetStaffTargetComplianceReport(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetStaffTargetComplianceReport$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetStaffTargetComplianceReport(params?: GetStaffTargetComplianceReport$Params, context?: HttpContext): Observable<StaffTargetComplianceReportModel> {
    return this.GetStaffTargetComplianceReport$Response(params, context).pipe(
      map((r: StrictHttpResponse<StaffTargetComplianceReportModel>): StaffTargetComplianceReportModel => r.body)
    );
  }

  /** Path part for operation `apiGraphGetBehaviorGraphGet()` */
  static readonly ApiGraphGetBehaviorGraphGetPath = '/api/Graph/GetBehaviorGraph';

  /**
   * This is the main method for generating the graphs for behaviors.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetBehaviorGraph()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetBehaviorGraph$Response(params?: GetBehaviorGraph$Params, context?: HttpContext): Observable<StrictHttpResponse<GraphDataModel>> {
    return GetBehaviorGraph(this.http, this.rootUrl, params, context);
  }

  /**
   * This is the main method for generating the graphs for behaviors.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetBehaviorGraph$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetBehaviorGraph(params?: GetBehaviorGraph$Params, context?: HttpContext): Observable<GraphDataModel> {
    return this.GetBehaviorGraph$Response(params, context).pipe(
      map((r: StrictHttpResponse<GraphDataModel>): GraphDataModel => r.body)
    );
  }

  /** Path part for operation `apiGraphGetSessionEntriesForBehaviorGet()` */
  static readonly ApiGraphGetSessionEntriesForBehaviorGetPath = '/api/Graph/GetSessionEntriesForBehavior';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetSessionEntriesForBehavior()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetSessionEntriesForBehavior$Response(params?: GetSessionEntriesForBehavior$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PatientSessionDataModel>>> {
    return GetSessionEntriesForBehavior(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetSessionEntriesForBehavior$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetSessionEntriesForBehavior(params?: GetSessionEntriesForBehavior$Params, context?: HttpContext): Observable<Array<PatientSessionDataModel>> {
    return this.GetSessionEntriesForBehavior$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PatientSessionDataModel>>): Array<PatientSessionDataModel> => r.body)
    );
  }

  /** Path part for operation `apiGraphGetDataTakerStaffsForBehaviorIdGet()` */
  static readonly ApiGraphGetDataTakerStaffsForBehaviorIdGetPath = '/api/Graph/GetDataTakerStaffsForBehaviorID';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetDataTakerStaffsForBehaviorID()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetDataTakerStaffsForBehaviorID$Response(params?: GetDataTakerStaffsForBehaviorID$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DataTakerStaffDataModel>>> {
    return GetDataTakerStaffsForBehaviorID(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetDataTakerStaffsForBehaviorID$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetDataTakerStaffsForBehaviorID(params?: GetDataTakerStaffsForBehaviorID$Params, context?: HttpContext): Observable<Array<DataTakerStaffDataModel>> {
    return this.GetDataTakerStaffsForBehaviorID$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<DataTakerStaffDataModel>>): Array<DataTakerStaffDataModel> => r.body)
    );
  }

  /** Path part for operation `apiGraphGetMixedGraphGet()` */
  static readonly ApiGraphGetMixedGraphGetPath = '/api/Graph/GetMixedGraph';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetMixedGraph()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetMixedGraph$Response(params?: GetMixedGraph$Params, context?: HttpContext): Observable<StrictHttpResponse<GraphDataModel>> {
    return GetMixedGraph(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetMixedGraph$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetMixedGraph(params?: GetMixedGraph$Params, context?: HttpContext): Observable<GraphDataModel> {
    return this.GetMixedGraph$Response(params, context).pipe(
      map((r: StrictHttpResponse<GraphDataModel>): GraphDataModel => r.body)
    );
  }

  /** Path part for operation `apiGraphGetGraphAnnotationsGet()` */
  static readonly ApiGraphGetGraphAnnotationsGetPath = '/api/Graph/GetGraphAnnotations';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetGraphAnnotations()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetGraphAnnotations$Response(params?: GetGraphAnnotations$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<GraphAnnotationModel>>> {
    return GetGraphAnnotations(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetGraphAnnotations$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetGraphAnnotations(params?: GetGraphAnnotations$Params, context?: HttpContext): Observable<Array<GraphAnnotationModel>> {
    return this.GetGraphAnnotations$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<GraphAnnotationModel>>): Array<GraphAnnotationModel> => r.body)
    );
  }

  /** Path part for operation `apiGraphSaveGraphAnnotationPost()` */
  static readonly ApiGraphSaveGraphAnnotationPostPath = '/api/Graph/SaveGraphAnnotation';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `SaveGraphAnnotation()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  SaveGraphAnnotation$Response(params?: SaveGraphAnnotation$Params, context?: HttpContext): Observable<StrictHttpResponse<GraphAnnotationModel>> {
    return SaveGraphAnnotation(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `SaveGraphAnnotation$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  SaveGraphAnnotation(params?: SaveGraphAnnotation$Params, context?: HttpContext): Observable<GraphAnnotationModel> {
    return this.SaveGraphAnnotation$Response(params, context).pipe(
      map((r: StrictHttpResponse<GraphAnnotationModel>): GraphAnnotationModel => r.body)
    );
  }

  /** Path part for operation `apiGraphSetGraphAnnotationVisibilityPost()` */
  static readonly ApiGraphSetGraphAnnotationVisibilityPostPath = '/api/Graph/SetGraphAnnotationVisibility';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `SetGraphAnnotationVisibility()` instead.
   *
   * This method doesn't expect any request body.
   */
  SetGraphAnnotationVisibility$Response(params?: SetGraphAnnotationVisibility$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return SetGraphAnnotationVisibility(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `SetGraphAnnotationVisibility$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  SetGraphAnnotationVisibility(params?: SetGraphAnnotationVisibility$Params, context?: HttpContext): Observable<void> {
    return this.SetGraphAnnotationVisibility$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiGraphMarkGraphAnnotationAsDeletedPost()` */
  static readonly ApiGraphMarkGraphAnnotationAsDeletedPostPath = '/api/Graph/MarkGraphAnnotationAsDeleted';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `MarkGraphAnnotationAsDeleted()` instead.
   *
   * This method doesn't expect any request body.
   */
  MarkGraphAnnotationAsDeleted$Response(params?: MarkGraphAnnotationAsDeleted$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return MarkGraphAnnotationAsDeleted(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `MarkGraphAnnotationAsDeleted$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  MarkGraphAnnotationAsDeleted(params?: MarkGraphAnnotationAsDeleted$Params, context?: HttpContext): Observable<void> {
    return this.MarkGraphAnnotationAsDeleted$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
